import { Box, useMediaQuery } from "@mui/material";
import { theme } from "../styles/mui-theme";

export const SecondaryModelCardAtom = ({
  imgSrc,
  position,
  isBackSide,
  isHidden = false,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const isOldMobile = useMediaQuery("(max-height: 640px)");
  const isUltraHd = useMediaQuery(theme.breakpoints.between("xl", "xxl"));
  const is4k = useMediaQuery(theme.breakpoints.up("xxl"));

  const cardWidth = () => {
    if (isMobile) {
      return "80px";
    } else if (isTablet) {
      return "150px";
    } else if (is4k) {
      return "400px";
    } else if (isUltraHd) {
      return "300px";
    } else {
      return "180px";
    }
  };

  const positions = {
    leftCenter: {
      left: "10%",
      top: "40%",
    },
    rightCenter: {
      right: "20%",
      top: "35%",
    },
    leftTop: {
      left: "20%",
      top: "5%",
    },
    leftBottom: {
      left: "20%",
      bottom: "-5%",
    },
    rightTop: {
      right: "10%",
      top: "5%",
    },
    rightBottom: {
      right: "5%",
      bottom: "10%",
    },
  };

  if (isHidden && isOldMobile) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        ...positions[position],
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        borderRadius: "12px",
        padding: "0",
        zIndex: isBackSide ? 3 : 5,
        filter: isBackSide && "blur(5px)",
      }}
    >
      <Box
        component="img"
        src={imgSrc}
        alt={`model-${imgSrc}`}
        sx={{
          objectFit: "contain",
          maxWidth: cardWidth(),
          width: "100%",
          margin: "0 auto",
          transform: "translateY(6px)",
          zIndex: isBackSide ? 3 : 5,
          filter: isBackSide && "blur(5px)",
        }}
      />
    </Box>
  );
};
